import React from "react";

import { styled } from '@material-ui/core';
import LoadingButton from "@material-ui/lab/LoadingButton";

const Root = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
});


interface Props {
  style: React.CSSProperties;
  loading?: boolean;
  disabled?: boolean;
  onClick: () => void;
}

const LoadMoreButton: React.FC<Props> = ({ style, loading, onClick, disabled, }) => {
  return (
    <Root style={style}>
      <LoadingButton loading={loading} onClick={onClick} disabled={disabled}>
        Load more
      </LoadingButton>
    </Root>
  );
};

export default LoadMoreButton;